import classnames from 'classnames';
import React from 'react';
import { Link } from 'react-router-dom';
import getDateFromISOToLocal from '~/utils/getDateFromISOToLocal';
import { useRecentActivity } from '../../providers';
const ComparisonActivityResult = ({ activity }) => {
    const { selectedDocument, setSelectedDocument, } = useRecentActivity();
    const selected = (selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.id) === activity.id;
    const comparisonLink = `/compare/${activity.documentComparisonId}${window.location.search}`;
    const details = activity.files.reduce((accu, file) => `${accu} ${file.name},`, '').slice(0, -1);
    const rowClass = classnames('recent-activity-result', { selected });
    return React.createElement("div", { className: rowClass, onClick: () => setSelectedDocument(activity) },
        React.createElement("div", { className: 'date-col' }, getDateFromISOToLocal(activity.timestamp)),
        React.createElement("div", { className: 'activity-col' },
            React.createElement(Link, { to: comparisonLink }, activity.documentComparisonActivityType)),
        React.createElement("div", { className: 'documents-col overflow-ellipsis' }, details));
};
export default ComparisonActivityResult;
